module.exports = __webpack_public_path__ + "static/sudhakar-a43d9ce7956616d43a376b49725fc724.svg";